import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import * as Highcharts from 'highcharts';
import { ActivityService } from './activity-statistcs.sevices';
// import {Chart} from 'angular-highcharts';

@Component({
  selector: 'app-activity-statistics',
  templateUrl: './activity-statistics.component.html',
  styleUrls: ['./activity-statistics.component.css']
})
export class ActivityStatisticsComponent implements OnInit {
  constructor(public activityService:ActivityService) { }

  @ViewChild('charts',{ static: true }) public chartEl:ElementRef;
  options={}
  y:number
  x:number
  form = new FormGroup({
    siteId: new FormControl(0),
    formData: new FormControl(null),
    toData: new FormControl(null),
    numberOfNewUsers : new FormControl(0),
    numberOfReturningUsers:new FormControl(0)
    })
  
  ngOnInit(){
       this.activityService.getList(this.form.value).subscribe(res=>
     { this.form.patchValue({'numberOfNewUsers':res.numberOfNewUsers , 'numberOfReturningUsers':res.numberOfReturningUsers})
    this.y=res.numberOfNewUsers
      this.x=res.numberOfReturningUsers
      this.createChart(this.chartEl.nativeElement ,this.optiondata())
    }
      )
    

}
optiondata(){
  this.options={
    chart:{
      plotBackgroundColor: null,
      plotBorderWidth: null,
      plotShadow: false,

      type: 'pie',
    },
    title: {
      text: '',
      // align: 'center',
      // verticalAlign: 'middle',
  },
  tooltip: {
    pointFormat: '{point.name}: <b>{point.percentage:.1f}%</b>'
  },
  accessibility: {
  point: {
      valueSuffix: '%'
  }
  },
  plotOptions: {
  pie: {
    allowPointSelect: true,
    cursor: 'pointer',
    size:220,
    colors: ['#008FC7', '#B3DEEE'],
    dataLabels: {
        enabled: true,
        format: '{point.percentage:.1f} %',
        distance:-50,
        filter :{
          property:'percentage',
          operator:'>',
          value: 4,
        }
        

    },
    showInLegend : true,
    innerSize: 60,
   // innerSize: '50%',
    // depth: 45
  //   enableMouseTracking: false
  
  }
  } ,
  series: [{
    findNearestPointBy: 'y',
  
      name: 'Brands',
      colorByPoint: true,
      keys: ['name', 'y', 'sliced', 'selected'],
      hovered:{
        hatchFill: "percent50"
      },
      data: [{
          name: 'New users',
          // color:'green',
          y:this.form.value.numberOfNewUsers,
          sliced: true,
          selected: true,
      }, {
          name: 'Regular Users',
          y: this.form.value.numberOfReturningUsers
          ,
          // sliced: true,
          // selected: true,
      },
      //  {
      //     name: 'graphic profille',
      //     y: 10.85
      // }, {
      //     name: 'site',
      //     y: 4.67
      // }, {
      //     name: 'products',
      //     y: 4.18
      // }, {
      //     name: 'users',
      //     y: 1.64
      // }, {
      //     name: 'priceing qutation',
      //     y: 1.6
      // }, 
    
    ]
  }]
  }
  return this.options
}


createChart(e1, cfg)
{
  Highcharts.chart(e1,cfg)
}


activityChart(){
  // this.options=document.getElementById('container')

 

}


get _numberOfNewUsers(){
  return (this.form.get('numberOfNewUsers'))

}
get _numberOfReturningUsers(){
  return (this.form.get('numberOfReturningUsers') )

}
}


